import { Component, DoCheck, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Models } from '@ibexfusion/models';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { AddItemsFromList } from '../../dialogs/add-items-from-list/add-items-from-list.component';
import { GroupHasFrontProfileService } from '@services/groups/group-has-frontprofile.service';
import { FrontProfilesService } from '@services/front-profiles/front-profiles.service';
import { ProfileService } from '@services/profiles/profile.service';
import { GroupService } from '@services/groups/group.service';
import {
  GroupHasRoleInOrganisationService
} from '@services/groups/group-has-role-in-organisation.service';
import { PackageInstalledAppsService } from '@services/packages/package-installed-apps.service';
import { GroupHasSecuredAppService } from '@services/groups/group-has-secured-app.service';
import { PackageService } from '@services/packages/package.service';
import { GroupHasProfileService } from '@services/groups/group-has-profile.service';
import { CredentialsService } from '@services/credentials/credentials.service';
import { OrganisationService } from '@services/organisations/organisation.service';
import { TranslateService } from '@services/translate/translate.service';
import { DialogService } from '@services/dialog/dialog.service';
import { MessengerService } from '@services/messenger/messenger.service';

@Component({
    selector: 'frontendgroup-edit-form',
    templateUrl: './frontendgroup-edit-form.component.html',
    styleUrls: ['./frontendgroup-edit-form.component.scss'],
    providers: [
        ProfileService, GroupService, GroupHasRoleInOrganisationService, PackageInstalledAppsService, GroupHasSecuredAppService,
        PackageService, GroupHasProfileService,
        CredentialsService, OrganisationService, FrontProfilesService, GroupHasFrontProfileService
    ],
    standalone: false
})
export class FrontendgroupEditFormComponent implements OnInit, DoCheck {
  @Input() organisationId;
  @Input() itemId;

  @Output() changed: EventEmitter<boolean> = new EventEmitter();
  hasChanged = false;

  group: Models.Group;
  profile: Models.Profile;
  displaySecuredContent = false;
  contentAuthor = false;
  securedContentAdmin = false;

  securedContent = false;
  orderModule = false;
  ticketingModule = false;
  ticketingEditor = false;
  securedItemsData: any;
  missingTitle = false;
  missingPermissions = false;

  title: string;
  ghrio: Models.GroupHasRoleInOrganisation[];
  ghsa: any[]
  packages: Models.Package[];
  packageInstalledApps: Models.PackageInstalledApp[];
  packageInstalledAppsSecured: Models.PackageInstalledApp[];
  packageInstalledAppsDynamicContent: Models.PackageInstalledApp[];
  existingSecuredItemConnections: Models.GroupHasSecuredApp[];
  securedItemColumns = [{ prop: 'title' }, { prop: 'packageInstalledAppId' }];
  headerButtonsSecuredContent = [{ icon: 'add', callback: () => {return this.addSecuredItem()} }];
  profiles: Models.FrontProfileModel[];
  activeProfiles: Models.FrontProfileModel[];
  ghfp: Models.GroupHasFrontProfile[];
  profileColumns = [{prop: 'lastName'}, {prop: 'firstName'}, {prop: 'email'}, {prop: 'mobile'}];
  headerButtons = [{ icon: 'add', callback: () => {return this.addProfile()}, tooltipTranslation: 'userAdmin.group.addProfile' }];
  history: any;
  systemMessages: any;

  isTicketingAdmin = false;
  isGastroAdmin = false;
  isSecuredContentAdmin = false;
  isSuperAdmin = false;

  constructor(
    private route: ActivatedRoute, private groupService: GroupService, private translate: TranslateService, private dialog: MatDialog,
    private ghrioService: GroupHasRoleInOrganisationService, private router: Router, private ghsaService: GroupHasSecuredAppService, private snackbar: SnackbarService,
    private appService: PackageInstalledAppsService, private packageService: PackageService, private dialogService: DialogService, private profileService: FrontProfilesService,
    private ghfpService: GroupHasFrontProfileService, private ms: MessengerService
  ) {
    this.ms.$activeRoles.subscribe(roles => {
      this.isTicketingAdmin = !!roles?.find((el: any) => el?.roleName === 'ticketingModuleAdmin');
      this.isGastroAdmin = !!roles?.find((el: any) => el?.roleName === 'orderModuleAdmin');
      this.isSecuredContentAdmin = !!roles?.find((el: any) => el?.roleName === 'securedContentAdmin');
    });
    this.ms.$activePrivileges.subscribe(privileges => {
      this.isSuperAdmin = !!privileges.find(priv => priv.privilegeName === 'superadmin' && priv.value === 'user-admin');
    });
  }

  @HostListener('window:beforeunload')
  @HostListener('window:beforeunload', ['$event'])
  canDeactivate(): Observable<boolean> | boolean | Promise<boolean> {
    return this.handleBeforeUnload();
  }

  async ngDoCheck() {
    if (this.hasChanged !== !this.handleBeforeUnload()) {
      this.hasChanged = !this.handleBeforeUnload();
      this.changed.emit(this.hasChanged);
    }
  }

  async ngOnInit() {
    this.title = this.translate.get('userAdmin.frontend-group.new');
    this.systemMessages = this.translate.get('system');
    this.group = new Models.Group();
    this.group.isPersonal = false;
    if (this.itemId) {
      this.group = await this.groupService.get(this.itemId);
      if ((this.group?.name || '').startsWith('pref_')) {
        this.group.name = this.group.name.split('_').splice(2, this.group.name.split('_').length - 1).join('_');
      }
      this.ghrio = (await this.ghrioService.find(0, 1000, { GroupID: this.itemId })).data;

      const roleMapping = { '45': ['securedContent', 'displaySecuredContent'], '49': 'orderModule', '53': 'ticketingModule', '55': 'ticketingEditor' };

      Object.keys(roleMapping).forEach(roleID => {
        const properties = roleMapping[roleID];
        if (Array.isArray(properties)) {
          properties.forEach(prop => this[prop] = !!this.ghrio.find(el => el.RoleID.toString() === roleID));
        } else {
          this[properties] = !!this.ghrio.find(el => el.RoleID.toString() === roleID);
        }
      });
      this.packages = (await this.packageService.find(0, 1000, { OwnerOrganisationID: this.organisationId })).data;
      this.packageInstalledApps = (await this.appService.find(0, 1000, { packageId: { $in: this.packages.map(el => el._id) } })).data;
      this.packageInstalledAppsSecured = this.packageInstalledApps.filter(el => !!el.isSecured);
      this.packageInstalledAppsDynamicContent = this.packageInstalledApps.filter(el => !!el.dynamicContentEntranceId);
      this.ghfp = (await this.ghfpService.find(0, 1000, { GroupID: this.group.GroupID })).data;
      const packageIds = (this.route.snapshot.params['packageId'] ? [this.route.snapshot.params['packageId']] : this.packages).map(pak => pak?._id?.toString() || pak?.toString() || pak);
      this.profiles = (await this.profileService.find(0, 1000, { packageId: { $in: packageIds }, isAnonymous: false })).data;
      this.activeProfiles = this.profiles.filter(profile => this.ghfp.map(el => el.ProfileID.toString()).includes(profile.FrontProfileID.toString()));
      await this.initFrontendGroups();
    }
    this.initHistory();
  }

  initHistory(): void {
    this.history = {};
    ['group', 'securedContent', 'orderModule', 'ticketingModule', 'ticketingEditor', 'securedItemsData'].forEach(field => {
      this.history[field] = JSON.stringify(this[field])
    });
  }

  handleBeforeUnload() {
    return !Object.keys(this?.history || {}).some(key => this.history?.[key] !== JSON.stringify(this?.[key]));
  }

  async initFrontendGroups() {
    this.title = this.translate.get('userAdmin.frontend-group.title') + ': ' + this.group.name;
    if (this.displaySecuredContent && this.isSecuredContentAdmin) {
      this.existingSecuredItemConnections = (await this.ghsaService.find(0, 1000, { Groups_GroupID: this.itemId })).data;
      const securedItems = [];
      this.existingSecuredItemConnections.forEach(el => {
        const securedApp = this.packageInstalledAppsSecured.find(app => app._id === el.packageInstalledAppId);
        let title = '';
        if (securedApp && securedApp.translations && securedApp.translations[0] && securedApp.translations[0].appTitle) {
          title = securedApp.translations[0].appTitle;
        }
        securedItems.push({ packageInstalledAppId: el.packageInstalledAppId, title })
      });
      this.securedItemsData = securedItems;
      this.ghsa = JSON.parse(JSON.stringify(this.securedItemsData));
    }
  }

  async save() {
    this.missingTitle = !this.group.name || this.group.name.length < 3;
    this.missingPermissions = (!this.securedContent && !this.orderModule && !this.ticketingModule && !this.ticketingEditor);
    if (this.missingTitle || this.missingPermissions) {
      return;
    }
    let res;
    try {
      const group = Object.assign({}, this.group);
      group.name = 'pref_' + this.organisationId + '_' + group.name;
      res = !!this.itemId ? await this.groupService.update(this.itemId, group) : await this.groupService.create(group);
    } catch (err) {
      return this.snackbar.open('Die Gruppe konnte nicht erstellt werden, möglicherweise existiert bereits eine Gruppe mit dem gleichen Namen, versuchen Sie es mit einem anderen Namen.', 10000);
    }
    await this.toggleRole(res.GroupID, this.securedContent, 45);
    await this.toggleRole(res.GroupID, this.orderModule, 49);
    await this.toggleRole(res.GroupID, this.ticketingModule, 53);
    await this.toggleRole(res.GroupID, this.ticketingEditor, 55);
    const oldItems = this.ghsa ? this.ghsa.filter(item => !this.arrayToMap(this.securedItemsData)[item.packageInstalledAppId]) : [];
    const newItems = this.securedItemsData ? this.securedItemsData.filter(item => !this.arrayToMap(this.ghsa)[item.packageInstalledAppId]) : [];
    for (const oldItem of oldItems) {
      await this.ghsaService.remove(this.existingSecuredItemConnections.find(el => el.packageInstalledAppId === oldItem.packageInstalledAppId).GroupHasSecuredAppID.toString());
    }
    for (const newItem of newItems) {
      await this.ghsaService.create({ packageInstalledAppId: newItem.packageInstalledAppId, Groups_GroupID: this.itemId || res.GroupID });
    }
    if (!this.itemId) {
      return this.router.navigate([res.GroupID], { relativeTo: this.route });
      // return this.router.navigate([this.router.url.split('/')[1], this.organisationId, 'frontend-groups', res.GroupID]);
    }
    const added = this.arrayDifference(this.activeProfiles.map(el => el.FrontProfileID), this.ghfp.map(el => el.ProfileID));
    const removed = this.arrayDifference(this.ghfp.map(el => el.ProfileID), this.activeProfiles.map(el => el.FrontProfileID));
    const promises = [];
    added.forEach(profileId => { promises.push(this.ghfpService.create({ ProfileID: profileId, GroupID: this.group.GroupID })) } );
    removed.map(profileId => this.ghfp.filter(g => g.ProfileID === profileId)).flat().map(el => el.ID).forEach(groupId => { promises.push(this.ghfpService.remove(groupId)); });
    await Promise.all(promises);
    this.ngOnInit();
  }

  arrayDifference(arr1, arr2) {
    const set2 = new Set(arr2);
    return arr1.filter(x => !set2.has(x));
  }

  arrayToMap(array, idField = 'packageInstalledAppId') {
    if (!array) {
      return [];
    }
    return array.reduce((map, item) => {
      map[item[idField]] = item;
      return map;
    }, {});
  }

  async abort() {
    if (!!this.handleBeforeUnload()) {
      this.router.navigate([this.router.url.split('/')[1], this.route.snapshot.params['packageId'] || this.organisationId]);
    } else {
      const confirmation = await this.dialogService.confirm(this.systemMessages['general']['pendingChanges']);
      if (confirmation) {
        this.router.navigate([this.router.url.split('/')[1], this.route.snapshot.params['packageId'] || this.organisationId]);
      }
    }
  }

  async toggleRole(groupId, activate, roleId) {
    const existing = !!this.ghrio ? this.ghrio.find(el => el.RoleID.toString() === roleId.toString()) : null;
    if (activate && !existing) {
      await this.ghrioService.create({ GroupID: groupId, RoleID: roleId, OrganisationID: this.organisationId });
    }
    if (!activate && !!existing) {
      await this.ghrioService.remove(existing.ID.toString());
    }
  }

  async addSecuredItem() {
    const items = JSON.parse(JSON.stringify(this.securedItemsData));
    const availableItems = this.packageInstalledAppsSecured.filter(el => !items.find(sub => sub.packageInstalledAppId === el._id));
    availableItems.forEach(el => {
      let title = '';
      if (el && el.translations && el.translations[0] && el.translations[0].appTitle) {
        title = el.translations[0].appTitle;
      }
      el['title'] = title;
    });
    const dialogRef = this.dialog.open(AddItemsFromList, {
      width: '1200px', data: { availableItems: availableItems, idField: '_id', columns: [{ prop: 'title' }, { prop: '_id' }] }
    });
    const result = await dialogRef.afterClosed().toPromise();
    this.securedItemsData = null;
    if (result && result.additionalItems) {
      result.additionalItems.forEach(el => {
        const securedApp = this.packageInstalledAppsSecured.find(app => app._id === el);
        let title = '';
        if (securedApp && securedApp.translations && securedApp.translations[0] && securedApp.translations[0].appTitle) {
          title = securedApp.translations[0].appTitle;
        }
        items.push({ packageInstalledAppId: el, title });
      });
    }
    setTimeout(() => {
      this.securedItemsData = items;
    }, 0);
  }

  async removeSecuredItem(event: any) {
    const items = JSON.parse(JSON.stringify(this.securedItemsData));
    this.securedItemsData = null;
    items.splice(items.findIndex(el => el.packageInstalledAppId === event.row.packageInstalledAppId), 1);
    this.securedItemsData = items;
    setTimeout(() => {
      this.securedItemsData = items;
    }, 0);
  }

  async addProfile() {
    const active = this.activeProfiles;
    const all = this.profiles;
    const profileIds = all.filter(el => !active.includes(el)).map(el => el.FrontProfileID);

    const chunkSize = 100;
    const promises = [];
    for (let i = 0; i < profileIds.length; i += chunkSize) {
        const chunk = profileIds.slice(i, i + chunkSize);
        promises.push(
          this.profileService.find(0, 1000, { FrontProfileID: { $in: chunk } })
        );
    }
    const responses = await Promise.all(promises);
    const items = responses.flatMap(res => res.data);
    // const items = (await this.profileService.find(0, 1000, { FrontProfileID: { $in: profileIds } })).data;
    const dialogRef = this.dialog.open(AddItemsFromList, { width: '1200px', maxHeight: '90vh', data: { availableItems: items, columns: this.profileColumns, idField: 'FrontProfileID' } });
    const result = await dialogRef.afterClosed().toPromise();
    this.activeProfiles = null;
    result?.additionalItems?.forEach(el => {
      active.push(this.profiles.find(profile => profile.FrontProfileID === el));
    });
    setTimeout(() => {
      this.activeProfiles = active;
    }, 0);
  }

  async removeProfile(event: any) {
    const items = JSON.parse(JSON.stringify(this.activeProfiles.filter(el => el.email !== event.row.email)));
    setTimeout(() => {
      this.activeProfiles = items;
    }, 0);
  }
}
